import { render } from "./InfoFin.vue?vue&type=template&id=24853adc"
import script from "./InfoFin.vue?vue&type=script&lang=js"
export * from "./InfoFin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__